import type { MaybeRefOrGetter } from "vue";
import type { ShortcutType } from "@/generated/models";
import { useQuery } from "@tanstack/vue-query";
import { sort } from "fast-sort";
import { computed, toValue } from "vue";
import { queries } from "./queries";

export function useRecents(fileType?: MaybeRefOrGetter<ShortcutType>) {
  const query = useQuery(computed(() => queries.recents(toValue(fileType))));

  const recents = computed(() => {
    if (!query.data.value) return undefined;
    const items = sort(query.data.value.Items).desc(b => b.Date);
    return items;
  });

  return recents;
}
